var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultRendererConfig, setupBingAerialImagery } from "./index";
import { sceneFlyover } from "./utils/sceneFlyover";
export function meshTilesetFlyover2(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "Mesh Tileset Flyover 2" +
                "</h1>" +
                "<p>" +
                "The camera will fly over a mesh tileset. The tileset should render normally" +
                "</p>";
        const initialWait = 5;
        const time = 2;
        const durations = [0, initialWait, time, time, time, time, time, time];
        const positions = [
            { longitude: -1.5719058232948182, latitude: 0.5228774178204263, height: 82.67843585882561 },
            { longitude: -1.5719058232948182, latitude: 0.5228774178204263, height: 82.67843585882561 },
            { longitude: -1.5719130658707967, latitude: 0.5228821545770074, height: 53.50270045782941 },
            { longitude: -1.5719130658707967, latitude: 0.5228821545770074, height: 53.50270045782941 },
            { longitude: -1.571906362665759, latitude: 0.5228777227801363, height: 53.32205578890439 },
            { longitude: -1.571907128606897, latitude: 0.5228764131357169, height: 55.39717232817134 },
            { longitude: -1.571905360876737, latitude: 0.5228762710320898, height: 53.07809186226178 },
            { longitude: -1.5719049397508051, latitude: 0.5228768987658915, height: 49.41451103949962 },
        ];
        const focuses = [
            { longitude: -1.5719128784271765, latitude: 0.5228820318965683, height: 53.420054415262705 },
            { longitude: -1.5719128784271765, latitude: 0.5228820318965683, height: 53.420054415262705 },
            { longitude: -1.5719134539458222, latitude: 0.5228817698222616, height: 51.61558622136399 },
            { longitude: -1.5719063323369458, latitude: 0.5228777163526305, height: 53.39019361564852 },
            { longitude: -1.5719063323369458, latitude: 0.5228777163526305, height: 53.39019361564852 },
            { longitude: -1.571880098648573, latitude: 0.5228721824998706, height: 0.44234942698038526 },
            { longitude: -1.5719011738148658, latitude: 0.5228809828297897, height: 45.58596412199439 },
            { longitude: -1.5719052940235085, latitude: 0.5228770294558305, height: 49.16458754914354 },
        ];
        yield sceneFlyover(defaultRendererConfig(container), durations, positions, focuses, (renderer) => __awaiter(this, void 0, void 0, function* () {
            // Scene setup
            setupBingAerialImagery(renderer);
            const object = yield renderer.getObjectFactory().createTileset({
                type: "direct",
                url: "https://s3.ap-southeast-2.amazonaws.com/skand.production.sites/5f0a197e80b803abb08180ae/62ab2d4b979fe3004d3b0957/62b7864442eb3e004d308f37/Files/Tileset3d/62b78d0642eb3e004d309feb/Scene/St_Louis_Cathedral.json",
            });
            object.setPositionECEF([0, 0, 100]);
            renderer.getWorld().addObject(object);
        }));
    });
}
